import { useQuery } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

type Params = {
  enabled: boolean
  page: number
  archiveDate: string | null
  ids: string[]
}
const useBulkUnableArchiveUsers = (params: Params) =>
  useQuery({
    queryKey: ['panelUsersCheckIneligibleForArchiveCreate', params],
    staleTime: 60 * 100,
    enabled: params.enabled,
    queryFn: async () =>
      httpService.panel.panelUsersCheckIneligibleForArchiveCreate({
        archive_date: params.archiveDate,
        users_ids: params.ids
      })
  })

export default useBulkUnableArchiveUsers
